import React, { useEffect, useState } from 'react';

import { fetchEventEnrichment, supportsEventEnrichment } from '../../lib/eventEnrichment';

export const EventLearningCard = ({ item }) => {
  const [enrichment, setEnrichment] = useState(null);
  const [loading, setLoading] = useState(false);
  const category = item?.category || '';
  const categoryLabel = item?.category_label || '';
  const title = item?.title || '';
  const name = item?.name || '';
  const summary = item?.summary || '';
  const description = item?.description || '';
  const eventType = item?.event_type || '';

  useEffect(() => {
    const learningTarget = {
      category,
      category_label: categoryLabel,
      title,
      name,
      summary,
      description,
      event_type: eventType,
    };

    if (!supportsEventEnrichment(learningTarget)) {
      setEnrichment(null);
      return;
    }

    let active = true;
    setLoading(true);

    fetchEventEnrichment(learningTarget)
      .then((payload) => {
        if (!active) return;
        setEnrichment(payload);
      })
      .finally(() => {
        if (!active) return;
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [category, categoryLabel, title, name, summary, description, eventType]);

  const learningTarget = {
    category,
    category_label: categoryLabel,
    title,
    name,
    summary,
    description,
    event_type: eventType,
  };

  if (!supportsEventEnrichment(learningTarget)) return null;

  return (
    <div className="atlas-event-learn-card">
      {enrichment?.image?.src ? (
        <div className="atlas-event-learn-media">
          <img src={enrichment.image.src} alt={enrichment.label} className="atlas-event-learn-image" />
        </div>
      ) : null}
      <div className="atlas-detail-stack">
        <span className="atlas-card-kicker">Learn this phenomenon</span>
        <h5 className="atlas-event-learn-title">{enrichment?.label || 'Open-source explainer'}</h5>
        <p className="atlas-card-copy">
          {loading ? 'Loading open-source explainer…' : enrichment?.summary || 'Open-source context is loading.'}
        </p>
        <div className="atlas-cta-row atlas-cta-row--tight">
          {enrichment?.learnUrl ? (
            <a href={enrichment.learnUrl} target="_blank" rel="noreferrer" className="atlas-secondary-link">
              Open source explainer
            </a>
          ) : null}
          {enrichment?.image?.pageUrl ? (
            <a href={enrichment.image.pageUrl} target="_blank" rel="noreferrer" className="atlas-secondary-link">
              Photo source
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};
